import React, { useState } from 'react'
import { StyledVolumeSlider, StyledButtonIcon, StyledControls } from './VolumeControl.style'
import { IconButton } from '@wsc_sports/components-library'

export interface Props {
  videoRef: React.RefObject<HTMLVideoElement>
}

const VolumeControl = ({ videoRef }: Props): JSX.Element => {
  const [volume, setVolume] = useState(0)
  const [previousVolume, setPreviousVolume] = useState(0.75)

  const onToggleMute = () => {
    if (videoRef.current) {
      if (videoRef.current.muted) {
        videoRef.current.volume = previousVolume
        videoRef.current.muted = false
        setVolume(previousVolume)
      } else {
        setPreviousVolume(videoRef.current.volume)
        videoRef.current.volume = 0
        videoRef.current.muted = true
        setVolume(0)
      }
    }
  }

  const onVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (videoRef.current) {
      const newVolume = event.target.valueAsNumber
      videoRef.current.volume = newVolume
      setVolume(newVolume)

      if (newVolume === 0) {
        videoRef.current.muted = true
      } else {
        videoRef.current.muted = false
        setPreviousVolume(newVolume)
      }
    }
  }

  return (
    <StyledControls>
      <StyledButtonIcon onClick={onToggleMute}>
        {videoRef.current?.muted ? (
          <IconButton
            name="volume_off"
            //TODO: Consult with designers what should be the IconButton type here and replace
            type="UNSAFE_transparent"
          />
        ) : (
          <IconButton
            name="volume_up"
            //TODO: Consult with designers what should be the IconButton type here and replace
            type="UNSAFE_transparent"
          />
        )}
      </StyledButtonIcon>
      <StyledVolumeSlider
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={onVolumeChange}
        style={{ width: '100%' }}
      />
    </StyledControls>
  )
}

export default VolumeControl
